import React from 'react';
import classNames from 'classnames';

import Icon, {
  HomeIcon,
  ClipboardIcon,
  ChatIcon,
  QuoteIcon,
  StarIcon,
  ArchiveIcon,
  TagIcon,
  UserCheckIcon
} from '../utils/icons';

const Concept = ({ json = {} }) => {
  const {
    name = [],
    rels = [],
    not_name = [],
    not_rels = [],
    attrs = [],
    not_attrs = []
  } = json;

  const formattedNames = name.map(name => (
    <div key={name} className="act-search-concept-json-name">
      {name}
    </div>
  ));

  const formattedAttrs = attrs.map(attr => (
    <div key={attr} className="act-search-concept-json-attrs">
      {attr}
    </div>
  ));

  const formattedRels = rels.map(([type, index]) => (
    <div key={`${type}-${index}`} className="act-search-concept-json-rel">
      <div className="act-search-concept-json-rel-type">{type}</div>
      <div className="act-search-concept-json-rel-index">{index}</div>
    </div>
  ));

  return (
    <div className="act-search-concept-json">
      {formattedNames} {formattedAttrs} {formattedRels}
    </div>
  );
};

const ActSearchCard = ({
  id,
  name = '',
  act = {
    name: ''
  },
  concepts = [],
  onClick = () => {}
}) => {
  const classes = classNames({
    'act-search': true
  });

  return (
    <div className={classes} onClick={onClick}>
      <div className="act-search-name">{name}</div>

      <div className="act-search-concepts">
        {concepts.map(concept => (
          <div key={concept.id} className="act-search-concept">
            <div className="act-search-concept-index">{concept.index}</div>
            <Concept json={concept.json} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActSearchCard;
